(function () {
  var tickIntervalId = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function setPromoDismissCookie() {
    var maxAge = 30 * 24 * 60 * 60;
    document.cookie = 'promo_banner=dismiss; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function afterSaleEnded(wrap) {
    if (tickIntervalId !== null) {
      clearInterval(tickIntervalId);
      tickIntervalId = null;
    }

    document.body.classList.remove('promo_banner-show');
    setPromoDismissCookie();

    var bar = wrap && wrap.closest ? wrap.closest('.announcementBar') : null;
    if (bar && bar.parentNode) {
      bar.parentNode.removeChild(bar);
    }

    var topBar = document.querySelector('.top_bar');
    if (topBar) {
      topBar.classList.remove('announcementBar--true');
      topBar.classList.add('announcementBar--false');
    }

    var logo = document.querySelector('.header-logo.topbarFixed--true');
    if (topBar && logo) {
      logo.style.marginTop = topBar.offsetHeight + 'px';
    }
  }

  function initAnnouncementCountdown() {
    var wrap = document.querySelector('[data-announcement-countdown]');
    if (!wrap) return;

    var endStr = wrap.getAttribute('data-end');
    if (!endStr) return;

    var endMs = new Date(endStr).getTime();
    if (isNaN(endMs)) return;

    var startStr = wrap.getAttribute('data-start');
    var startMs = startStr ? new Date(startStr).getTime() : null;
    if (startMs !== null && isNaN(startMs)) startMs = null;

    var labelStart = wrap.getAttribute('data-label-start') || 'Starts in';
    var labelEnd = wrap.getAttribute('data-label-end') || 'Ends in';

    var labelEl = wrap.querySelector('.announcementBar__countdown-label');
    var hEl = wrap.querySelector('[data-cd-h]');
    var mEl = wrap.querySelector('[data-cd-m]');
    var sEl = wrap.querySelector('[data-cd-s]');

    function tick() {
      var now = Date.now();

      if (now >= endMs) {
        afterSaleEnded(wrap);
        return;
      }

      var targetMs;
      var label;

      if (startMs !== null && now < startMs) {
        targetMs = startMs;
        label = labelStart;
      } else {
        targetMs = endMs;
        label = labelEnd;
      }

      var diff = Math.max(0, targetMs - now);
      var totalSec = Math.floor(diff / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var sec = totalSec % 60;

      if (labelEl) labelEl.textContent = label;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(sec);
    }

    tick();
    if (Date.now() >= endMs) return;
    tickIntervalId = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementCountdown);
  } else {
    initAnnouncementCountdown();
  }
})();
